import { Table, theme } from "antd";
import { memo, useEffect, useRef, useState } from "react";
import ResizeObserver from "rc-resize-observer";
import { VariableSizeGrid as Grid } from "react-window";

const VirtualTable = (props) => {
  const { columns, scroll } = props;
  const [tableWidth, setTableWidth] = useState(0);
  const { token } = theme.useToken();
  const widthColumnCount = columns.filter(({ width }) => !width).length;
  const mergedColumns = columns.map((column) => {
    if (column.width) {
      return column;
    }
    return {
      ...column,
      width: Math.floor(tableWidth / widthColumnCount),
    };
  });

  console.log("tableProps11234", props);
  return (
    <Table
      {...props}
      className="virtual-table"
      columns={mergedColumns}
      scroll={scroll}
    />
  );
};

export default memo(VirtualTable);
